export default __webpack_public_path__ + "static/media/albert.1726f281.jpeg";